import { Box, Typography } from '@mui/material';
import i18n from '../../i18';
import SearchBox from '../../search-box/SearchBox';
import React from 'react';
import { LocationBulkIcon } from '../../icons-lib/bulkIcons';
const icon = <LocationBulkIcon />;
export default class DialogEntityField extends React.Component {
    render() {
        // props: field, value, onChange, error, helperText, disabled
        let items = this.props.field.items;
        const label = i18n.t(`columns.${this.props.field.label}`);

        // Sort provinces alphabetically by name
        if (
            this.props.field.id === 'province' ||
            this.props.field.label === 'province' ||
            this.props.field.filterBy === 'province'
        ) {
            items = [...items].sort((a, b) => {
                return a.name.localeCompare(b.name, i18n.language || 'en', {
                    sensitivity: 'base',
                    numeric: true
                });
            });
        }

        return (
            <Box sx={{ mb: 2 }}>
                <Typography variant="subtitle2">
                    {label + (this.props.field.required ? ' *' : '')}
                </Typography>
                <SearchBox
                    handleChange={(value) =>
                        this.props.onChange(this.props.field.id, value)
                    }
                    icon={icon}
                    translatedLabel={label}
                    multiple={false}
                    value={this.props.value}
                    primaryTitle={label}
                    primaryKey={'name'}
                    items={items}
                    wrapperRef={this.props.wrapperRef}
                    addAssociationLabel={i18n.t(
                        `buttons.${this.props.field.label}Add`
                    )}
                    translatedSearchLabel={i18n.t(
                        `columns.${this.props.field.label}`
                    )}
                />
            </Box>
        );
    }
}
